module.exports = __webpack_public_path__ + "fonts/bef0ba4.eot";